import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { logoBlack } from "@/lib/cdn-images";

const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Partner", to: "/partner" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact / Apply", to: "/contact" },
];

const GIVE_URL = "https://give.abbashouse.org";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={() => setMobileOpen(false)}>
            <img src={logoBlack} alt="Abba's House Communities" width={253} height={70} className="h-10 md:h-14 w-auto" decoding="async" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors hover:opacity-70 ${
                    isActive ? "border-b-2 border-foreground pb-0.5" : "text-foreground"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          {/* Desktop Give Button */}
          <div className="hidden md:block">
            <a
              href={GIVE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-semibold tracking-wide hover:opacity-80 transition-opacity"
            >
              Give Now
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden p-2 text-foreground"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background z-40 flex flex-col px-6 pt-10 pb-8 gap-8">
          <nav className="flex flex-col gap-6">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-2xl font-semibold tracking-wide transition-opacity hover:opacity-60 ${
                    isActive ? "opacity-100" : "opacity-80"
                  }`
                }
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <a
            href={GIVE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-primary text-primary-foreground text-lg font-semibold tracking-wide hover:opacity-80 transition-opacity"
            onClick={() => setMobileOpen(false)}
          >
            Give Now
          </a>
        </div>
      )}
    </header>
  );
}